import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FieldError from '../../common/FieldError';
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { initialAuthenicate } from '../auth/ducks/auth';
import { toast } from 'react-toastify';

export const ChangeUser = ({ active = false }) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const auth = useSelector(state => state.auth);
    const [errors, setErrors] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    const queryclient = useQueryClient();

    const gradeRef = useRef();
    const schoolClassRef = useRef();
    const studentNumRef = useRef();


    useEffect(() => {
        setName(auth.name);
    }, [auth]);

    const userStoreMutate = useMutation({
        mutationFn: (data) => Api.post('/api/user/change/user', data),
        onSuccess: () => {
            queryclient.invalidateQueries({ queryKey: ['user/info', auth.id] });
            dispatch(initialAuthenicate());
            toast.success("정상적으로 수정되었습니다.");
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err);
            if (errorData.errors.length > 0) {
                setErrors(errorData.errors);
            } else {
                setErrorMessage(errorData.message);
                toast.error(errorData.message);
            }
        }
    });

    function onStore() {
        if (userStoreMutate.isPending) return;
        setErrors([]);
        setErrorMessage("");

        const updateData = {
            name, grade: gradeRef.current.value,
            schoolClass: schoolClassRef.current.value,
            studentNum: studentNumRef.current.value
        };

        userStoreMutate.mutate(updateData);
    }

    if (!active) return null;
    return (
        <div className="join show">
            <div className="join_input_area tab_body">
                <div className="row">
                    <h4>별명 또는 이름</h4>
                    <FieldError name="name" errors={errors} >
                        <input type="text" name="name" value={name || ''} maxLength="15" onChange={e => setName(e.target.value)} />
                    </FieldError>
                </div>
                <div className="row">
                    <div className="col4">
                        <h4>학년</h4>
                        <FieldError name="grade" errors={errors} >
                            <input type="number" ref={gradeRef} max={7} defaultValue={auth.grade}
                                onBlur={(e) => {
                                    if (e.target.value < 1) e.target.value = 1;
                                    if (e.target.value > 7) e.target.value = 7;
                                }} />
                        </FieldError>
                    </div>
                    <div className="col4">
                        <h4>반</h4>
                        <FieldError name="schoolClass" errors={errors} >
                            <input type="number" ref={schoolClassRef} max={20} defaultValue={auth.schoolClass}
                                onBlur={(e) => {
                                    if (e.target.value < 1) e.target.value = 1;
                                    if (e.target.value > 20) e.target.value = 20;
                                }} />
                        </FieldError>
                    </div>
                    <div className="col4">
                        <h4>번호</h4>
                        <FieldError name="studentNum" errors={errors} >
                            <input type="number" ref={studentNumRef} max={40} defaultValue={auth.studentNum}
                                onBlur={(e) => {
                                    if (e.target.value < 1) e.target.value = 1;
                                    if (e.target.value > 40) e.target.value = 40;
                                }} />
                        </FieldError>
                    </div>
                </div>
                {errorMessage !== '' && <p className="errorMessage text-center">{errorMessage}</p>}
            </div>
            <div className="btn_area">
                <button type="button" className="btn _blue" onClick={onStore}>저장</button>
            </div>
        </div>
    );
};